import { Directive, AfterViewInit, OnDestroy, Optional, Inject, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';


@Directive({ selector: '[tab-directive]' })
export class SelectOnTabDirective<TValue> implements AfterViewInit, OnDestroy {

    @Input()
    public readonly isActive: boolean = true;
    @Input()
    public readonly isFormPatchValueActive: boolean = false;
    @Input()
    public readonly formControl: FormControl;

    private observable: Subscription;
    constructor(
        private readonly autoTrigger: MatAutocompleteTrigger
    ) {}

    public ngAfterViewInit(): void {
        if (this.isActive){
            this.observable = this.autoTrigger.panelClosingActions
                .subscribe((): void => {
                    if (this.autoTrigger.activeOption) {
                        const value: TValue = this.autoTrigger.activeOption.value;
                        this.autoTrigger.writeValue(value);
                        if (this.formControl && this.isFormPatchValueActive){
                            this.formControl.patchValue(value);
                        }
                    }
                });
        }
    }

    public ngOnDestroy(): void {
        if(this.observable){
            this.observable.unsubscribe();
        }
    }
}